/* ==========================================================================
   MYGANG grozs: prioritārās izgatavošanas rūtiņa.
   Atzīmējot pievieno paslēpto pakalpojuma preci, noņemot to izņem.
   Pēc katras izmaiņas lapa tiek pārlādēta, lai visas summas un piegādes
   aprēķini būtu garantēti pareizi.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-mg-priority]';

  function findLineKey(cart, variantId) {
    for (var i = 0; i < cart.items.length; i += 1) {
      if (cart.items[i].variant_id === variantId) return cart.items[i].key;
    }
    return null;
  }

  function setBusy(root, busy) {
    root.classList.toggle('is-busy', busy);
    var input = root.querySelector('.mg-priority__input');
    if (input) input.disabled = busy;
  }

  function init(root) {
    var input = root.querySelector('.mg-priority__input');
    if (!input || root.dataset.mgPriorityReady === 'true') return;
    root.dataset.mgPriorityReady = 'true';

    var variantId = Number(root.getAttribute('data-variant-id'));
    if (!variantId) return;

    input.addEventListener('change', function () {
      var wantsIt = input.checked;
      setBusy(root, true);

      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var key = findLineKey(cart, variantId);

          if (wantsIt && key) return null;
          if (!wantsIt && !key) return null;

          if (wantsIt) {
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
          }

          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          setBusy(root, false);
          input.checked = !wantsIt;
        });
    });
  }


  /* Preču skaita vārds pareizā locījumā, arī pēc AJAX daudzuma maiņas. */
  function countWord(el, n) {
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (mod10 === 0 || (mod100 >= 11 && mod100 <= 19)) return el.dataset.wordMany;
    if (mod10 === 1) return el.dataset.wordOne;
    return el.dataset.wordFew;
  }

  function decorateCount() {
    var el = document.querySelector('[data-mg-count]');
    if (!el || !el.dataset.wordOne) return;
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (isNaN(n)) return;
    var wanted = n + ' ' + countWord(el, n);
    if (el.textContent.trim() !== wanted) el.textContent = wanted;
  }

  function watchCount() {
    var el = document.querySelector('[data-mg-count]');
    if (!el || el.dataset.mgWatched === 'true') return;
    el.dataset.mgWatched = 'true';
    new MutationObserver(decorateCount).observe(el, { childList: true, characterData: true, subtree: true });
    decorateCount();
  }


  /* "€35 no €100" blakus bezmaksas piegādes ziņai, kā dizainā. */
  function progressAmount() {
    var block = document.querySelector('.cart-block--progress .free-shipping');
    if (!block || block.querySelector('.mg-progress__amount')) return;

    var limit = parseFloat(block.getAttribute('data-free-shipping-limit'));
    if (!limit || isNaN(limit)) return;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var word = { lv: 'no', en: 'of', et: 'kokku' };
        var lang = (document.documentElement.lang || 'lv').slice(0, 2);
        var span = document.createElement('span');
        span.className = 'mg-progress__amount';
        span.textContent = '€' + Math.round(cart.total_price / 100) + ' ' +
          (word[lang] || word.lv) + ' €' + Math.round(limit);
        var msg = block.querySelector('.free-shipping__default-message') ||
                  block.querySelector('.free-shipping__success-message');
        if (msg && msg.parentNode) msg.parentNode.insertBefore(span, msg.nextSibling);
      })
      .catch(function () {});
  }


  /* --------------------------------------------------------------------
     Vārda un uzvārda labošana tieši grozā. Klikšķis uz rindas pārvērš
     vērtību par ievadlauku; Enter vai peles novirzīšana saglabā.
     -------------------------------------------------------------------- */

  function saveProperty(lineKey, name, value, row) {
    row.classList.add('is-saving');

    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i += 1) {
          if (cart.items[i].key === lineKey) line = cart.items[i];
        }
        if (!line) return null;

        var props = {};
        Object.keys(line.properties || {}).forEach(function (k) {
          props[k] = line.properties[k];
        });
        props[name] = value;

        return fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: line.quantity, properties: props })
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function () { row.classList.remove('is-saving'); });
  }

  function startEdit(row, lineKey) {
    if (row.querySelector('input')) return;

    var span = row.querySelector('[data-property-value]');
    if (!span) return;

    var name = row.getAttribute('data-property-name');
    var current = span.textContent.trim();

    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'mg-property-input';
    input.value = current;
    input.maxLength = 20;
    input.setAttribute('aria-label', name);

    span.replaceWith(input);
    input.focus();
    input.select();

    var done = false;
    function finish(save) {
      if (done) return;
      done = true;
      var value = input.value.trim();
      if (!save || value === current || value === '') {
        var back = document.createElement('span');
        back.setAttribute('data-property-value', '');
        back.textContent = current;
        input.replaceWith(back);
        return;
      }
      saveProperty(lineKey, name, value, row);
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); finish(true); }
      if (e.key === 'Escape') { e.preventDefault(); finish(false); }
    });
    input.addEventListener('blur', function () { finish(true); });
  }

  function initEditableProperties() {
    document.querySelectorAll('.cart__item').forEach(function (item) {
      var lineKey = item.getAttribute('data-item');
      if (!lineKey) return;

      item.querySelectorAll('.cart__item__property[data-property-name]').forEach(function (row) {
        if (row.dataset.mgEditReady === 'true') return;
        row.dataset.mgEditReady = 'true';
        row.classList.add('mg-editable');
        row.setAttribute('role', 'button');
        row.setAttribute('tabindex', '0');

        row.addEventListener('click', function () { startEdit(row, lineKey); });
        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); startEdit(row, lineKey); }
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(init);
    watchCount();
    progressAmount();
    initEditableProperties();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('theme:cart:change', boot);
})();
